import { AdminLayout } from "@/components/admin/AdminLayout";
import { ListEditor } from "@/components/admin/ListEditor";

export default function ContentPage() {
  return (
    <AdminLayout title="Why Choose Us & Services" testId="admin-content-page">
      <ListEditor
        title="Why Choose Us points"
        endpoint="points"
        testPrefix="point"
        addLabel="Add point"
        fields={[{ key: "text", label: "New point (one line)", requiredMsg: "Text is required" }]}
      />
      <ListEditor
        title="Services"
        endpoint="services"
        testPrefix="service"
        addLabel="Add service"
        fields={[
          { key: "title", label: "Service title", requiredMsg: "Title is required" },
          { key: "description", label: "Short description (optional)", area: true },
        ]}
      />
    </AdminLayout>
  );
}
